import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface ChargePointsLastMessageCellProps
  extends CellContext<
    GatewayChargePointInMaintenanceModel,
    GatewayChargePointInMaintenanceModel['lastHeartbeatTime']
  > {}

export const ChargePointsLastMessageCell = (
  props: ChargePointsLastMessageCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();

  return <Text truncate>{value ? formatDate(value, i18n) : '-'}</Text>;
};
